import React, {FC} from "react"
import {Grid} from "react-bootstrap"
import {withTheme, WithDefaultTheme} from "styled-components"
import {RouteComponentProps} from "react-router-dom"

import AppContainer from "@irati/ui/src/AppContainer"
import ContactPreferences from "@irati-web/account/src/components/ContactPreferences"
import {FormattedMessage} from "@irati/utils/lang"
import {H1} from "@irati/ui/src/Typography"

import ContactPreferencesNav from "./Nav"

import {Header} from "./styled"

interface Props extends RouteComponentProps<{userId: string, signature: string}>, WithDefaultTheme {}

const ContactPreferencesExternal: FC<Props> = ({theme, match}) => {
  return (
    <AppContainer mainBackground={theme.colors.utility.white}>
      <ContactPreferencesNav />
      <Header>
        <Grid>
          <H1 color={theme.colors.primary2}>
            <FormattedMessage id="platform.contactPreferences.external.heading" />
          </H1>
        </Grid>
      </Header>
      <ContactPreferences unAuthed match={match} />
    </AppContainer>
  )
}

export default withTheme(ContactPreferencesExternal)
